<template>
    <v-parallax v-if="data.image" :src="data.image.url" :height="data.height">
        <v-layout column align-center justify-center>
            <div class="text-xs-center" :style="{ color: data.text_color }">
                <div class="display-2" v-if="data.text">
                    {{ data.text }}
                </div>
                <div class="display-1" v-if="data.sub_text">
                    {{ data.sub_text }}
                </div>
                <div class="title" v-if="data.title">
                    {{ data.title }}
                </div>
            </div>
        </v-layout>
    </v-parallax>
</template>

<script>
    export default {
        props: [
            'data'
        ]
    }
</script>

<style lang="stylus" scoped>
    .title {
        font-size 17px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Parallax.vue